import type { CityConfig } from "../city-template/types";

export const muscatineConfig: CityConfig = {
  city: "Muscatine",
  state: "Iowa",
  stateAbbr: "IA",
  slug: "muscatine",
  route: "/cities/muscatine",
  title: "Emergency Passport Muscatine, IA | Expedited Passport Services | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Muscatine, IA — as fast as 24 hours. Serving Muscatine County and Mississippi River communities. A+ BBB rated registered State Dept. courier serving HNI Corporation and Allsteel professionals, Bayer Crop Science and Kent Feeds workers, and Pearl of the Mississippi travelers. No office visit required.",
  h1: "Emergency & Expedited Passport Services in Muscatine, IA",
  heroSubtitle: "HNI Corporation international dealer conference in Germany with a week's notice and your passport needs renewal? Bayer Crop Science research trip to South America and documents aren't ready? Family reunion in Italy departing in 6 days? We help Muscatine and Mississippi River community residents get their passports fast — as fast as 24 hours. A+ BBB rated registered State Dept. courier. Best price guarantee. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Muscatine%20Iowa%20Mississippi%20River%20waterfront%20with%20historic%20downtown%20brick%20buildings%20Pearl%20of%20the%20Mississippi%20industrial%20heritage%20riverfront%20parks%20and%20bridges%20Southeast%20Iowa%20river%20community%20at%20golden%20hour%20warm%20sunlight%20on%20the%20water&width=1800&height=700&seq=muscatine-hero-ia-2026&orientation=landscape",
  heroImageAlt: "Muscatine Iowa Mississippi River waterfront and historic downtown Southeast Iowa at golden hour",
  geoPosition: "41.4245;-91.0432",
  geoPlacename: "Muscatine, Iowa",
  regionalAgency: {
    name: "Chicago Passport Agency",
    address: "101 Ida B Wells Dr, 9th Floor, Chicago, IL 60604",
    distance: "Located in the Chicago Loop — approximately 215 miles east of Muscatine via I-80",
  },
  nearbyCitiesZips: [
    { name: "Muscatine", zips: "52761" },
    { name: "Wilton", zips: "52778" },
    { name: "West Liberty", zips: "52776" },
    { name: "Durant", zips: "52747" },
    { name: "Walcott", zips: "52773" },
    { name: "Blue Grass", zips: "52726" },
    { name: "Wapello", zips: "52653" },
    { name: "Columbus Junction", zips: "52738" },
    { name: "Tipton", zips: "52772" },
    { name: "Nichols", zips: "52766" },
    { name: "Davenport", zips: "52801–52807" },
    { name: "Bettendorf", zips: "52722" },
    { name: "Iowa City", zips: "52240–52246" },
    { name: "Coralville", zips: "52241" },
    { name: "Burlington", zips: "52601" },
    { name: "Rock Island, IL", zips: "61201" },
    { name: "Moline, IL", zips: "61265" },
    { name: "Cedar Rapids", zips: "52401–52411" },
    { name: "Des Moines", zips: "50301–50327" },
    { name: "Washington", zips: "52353" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier submission for urgent Mississippi River region departures" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your case from start to finish" },
    { icon: "ri-map-pin-2-line", title: "River Region Coverage", desc: "Serving Muscatine County and Quad Cities corridor" },
  ],
  internalLinks: [
    { name: "Expedited passport services in Davenport, IA", route: "/cities/davenport" },
    { name: "Fast passport renewal in Bettendorf, IA", route: "/cities/bettendorf" },
    { name: "Emergency passport help in Iowa City, IA", route: "/cities/iowa-city" },
    { name: "Urgent passport services in Burlington, IA", route: "/cities/burlington-ia" },
    { name: "Same-day passport help in Cedar Rapids, IA", route: "/cities/cedar-rapids" },
    { name: "Passport courier services in Des Moines, IA", route: "/cities/des-moines" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Muscatine remotely via secure courier. We do not have a walk-in office in Muscatine — our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for Muscatine County and the entire Mississippi River corridor region.",
  fpcOfficeAddress: "525 N Tryon St., Charlotte, NC 28202",
  fpcOfficeDistance: "Serving all of Muscatine County and the Mississippi River corridor including Wilton, West Liberty, Durant, and the Quad Cities region",
  serviceAreaIntro: "From the HNI Corporation and Allsteel headquarters driving office furniture innovation worldwide to Bayer Crop Science's research and development campus, from the historic Pearl Button Museum celebrating Muscatine's pearl button heritage to Kent Feeds and the agricultural processing corridor along the Mississippi, from the Muscatine riverfront parks and marina to the Highway 61 corridor connecting the Quad Cities — Fast Passport Center serves the entire Muscatine region. We regularly help travelers from Muscatine, Wilton, West Liberty, and Durant get their passports fast without the 3.5-hour drive to Chicago.",
  nearbyCitiesIntro: "We serve all Muscatine neighborhoods and the surrounding Mississippi River corridor including Wilton, West Liberty, Durant, Walcott, Blue Grass, Wapello, and Columbus Junction. If you are anywhere in Muscatine County or the Quad Cities region, we have you covered.",
  howItWorksIntro: "Most Muscatine travelers complete everything online and ship documents overnight. No need to drive to Chicago or wait in line at the regional agency.",
  mistakesIntro: "Mississippi River region travelers often face a 3.5-plus-hour drive to the nearest regional passport agency in Chicago. Here are the most common mistakes that cause delays.",
  testimonialsIntro: "Muscatine and Muscatine County travelers trust us when their departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in Muscatine? Here are the most common ones we hear from Mississippi River community travelers.",
  statePageRoute: "/states/iowa",
  statePageName: "Iowa",
  dmvWebsite: "https://iowadot.gov/mvd",
  dmvLabel: "Iowa DOT — Motor Vehicle Division",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Appointment required — no walk-ins allowed",
        "Life-or-death emergencies only",
        "Bereavement or medical crisis",
        "Expect to wait all day or return next day",
      ],
      highlight: false,
      emergency: true,
    },
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Predictable turnaround",
        "Ideal for upcoming trips",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than self-service",
        "Good for planned travel",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–3",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "No courier access — standard mail only",
        "Workload & wait times shift with shutdowns",
        "In-person clerk appointment required",
        "No document review — errors cause rejection",
        "No dedicated agent — you are on your own",
        "Updates only by physical mail letter",
        "No phone or email contact for your case",
        "Can't upgrade speed after submission",
        "Not suitable if travel is within 10 weeks",
      ],
      highlight: false,
      muted: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For Muscatine travelers with immediate departure needs — as fast as 24 hours for urgent international flights from MLI.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Flight verification support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for adults with a护照 issued within the last 15 years at age 16 or older.",
      bullets: ["No clerk visit required for most", "Mail-in or courier options", "Lost passport replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support in Muscatine County.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement with DS-64 form guidance and police report documentation.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement options"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal changes.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
    {
      icon: "ri-bank-card-line",
      title: "Passport Card",
      description: "Wallet-sized U.S. Passport Card for land and sea travel to Canada, Mexico, Bermuda, and the Caribbean.",
      bullets: ["REAL ID compliant alternative", "Fits in your wallet", "Land/sea border crossing approved"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-card",
    },
    {
      icon: "ri-error-warning-line",
      title: "Damaged Passport",
      description: "Replacement for water-damaged, torn, or otherwise mutilated passports that are no longer valid for travel.",
      bullets: ["Damage assessment guidance", "DS-11 replacement process", "Supporting documentation help"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=damaged-passport",
    },
    {
      icon: "ri-file-copy-line",
      title: "Second Passport",
      description: "Obtain a second valid U.S. passport for frequent international travelers who need overlapping visas.",
      bullets: ["For frequent business travelers", "Overlapping visa support", "Expedited processing available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=second-passport",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
    { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
    { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
    { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
    { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
    { name: "Passport Card", description: "Wallet-sized U.S. Passport Card for land and sea travel to Canada, Mexico, Bermuda, and the Caribbean." },
    { name: "Damaged Passport", description: "Replacement for water-damaged, torn, or mutilated passports requiring DS-11 replacement." },
    { name: "Second Passport", description: "Second valid U.S. passport for frequent international travelers with overlapping visa needs." },
  ],
  testimonials: [
    {
      name: "Frank W.",
      location: "Muscatine, IA",
      rating: 5,
      text: "HNI Corporation sent me to our international dealer conference in Cologne with 5 days notice. Fast Passport Center renewed my passport in 2 days. The CEO noticed I made it and asked how — now HNI has a corporate account with them.",
      service: "Passport Renewal",
    },
    {
      name: "Maria L.",
      location: "Muscatine, IA",
      rating: 5,
      text: "Bayer Crop Science research trip to Argentina — 4 days notice and my passport expired. Fast Passport Center's courier got it in 48 hours. I was in the field collecting soybean samples on schedule. My research team was amazed.",
      service: "Emergency Passport",
    },
    {
      name: "Greg and Nancy H.",
      location: "West Liberty, IA",
      rating: 5,
      text: "Family reunion in Sicily — 40 relatives from around the world. Realized our passports expired 5 days before. Fast Passport Center got both renewed in 3 days. We made it — Nonna was so happy to have everyone together!",
      service: "Passport Renewal",
    },

  ],
  facilities: [
    {
      id: "muscatine-1",
      name: "Muscatine Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "3100 Highway 61",
      city: "Muscatine",
      state: "IA",
      zip: "52761",
      phone: "(563) 263-6331",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Muscatine city center",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Muscatine facility. Serves Muscatine County. Appointments strongly recommended.",
      icon: "ri-mail-line",
    },
    {
      id: "muscatine-2",
      name: "Muscatine County Recorder's Office",
      type: "County Recorder Passport Acceptance",
      address: "414 E 3rd St",
      city: "Muscatine",
      state: "IA",
      zip: "52761",
      phone: "(563) 263-7741",
      hours: "Mon–Fri: 8:00 AM – 4:30 PM",
      distance: "Muscatine County Courthouse",
      website: "https://www.muscatinecountyiowa.gov/recorder",
      websiteLabel: "Muscatine County Recorder",
      notes: "Accepts passport applications. Extended weekday hours. Good alternative to post office.",
      icon: "ri-government-line",
    },
    {
      id: "muscatine-3",
      name: "West Liberty Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "109 E 3rd St",
      city: "West Liberty",
      state: "IA",
      zip: "52776",
      phone: "(319) 627-2411",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "15 miles northwest of Muscatine",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves West Liberty and northern Muscatine County. Full passport services.",
      icon: "ri-mail-line",
    },
    {
      id: "muscatine-4",
      name: "Wilton Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "115 W 4th St",
      city: "Wilton",
      state: "IA",
      zip: "52778",
      phone: "(563) 732-2621",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "15 miles north of Muscatine",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Wilton and Cedar County. Full passport services available.",
      icon: "ri-mail-line",
    },
    {
      id: "muscatine-5",
      name: "Davenport Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "401 W 2nd St",
      city: "Davenport",
      state: "IA",
      zip: "52801",
      phone: "(563) 322-2711",
      hours: "Mon–Fri: 8:00 AM – 5:00 PM",
      distance: "30 miles northeast of Muscatine",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Largest USPS facility in the Quad Cities. Extended hours available.",
      icon: "ri-mail-line",
    },
    {
      id: "muscatine-6",
      name: "Wapello Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "108 S 2nd St",
      city: "Wapello",
      state: "IA",
      zip: "52653",
      phone: "(319) 523-4311",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "20 miles south of Muscatine",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Louisa County. Full passport services available.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 3.5+ hour drive to Chicago", fpc: "No — ship from home or office" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Photo shops in the Quad Cities region often use generic sizes. Passport photos must be exactly 2×2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 reasons for rejection at Muscatine County acceptance facilities.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Fees change frequently. Many Muscatine applicants show up with incorrect payment and have to reschedule their appointment.",
    },
    {
      icon: "ri-calendar-close-line",
      title: "No Proof of Travel",
      description: "Without flight confirmation or travel itinerary, the Chicago regional agency will turn you away for emergency appointments.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For minors, both parents must appear or submit notarized consent. This trips up many Muscatine Community School District families at the county clerk.",
    },
    {
      icon: "ri-time-line",
      title: "Waiting Too Long to Start",
      description: "Muscatine travelers often assume they have plenty of time with standard processing. It takes 8–11 weeks. Start expedited at least 3 weeks before travel.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS location in Muscatine." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy before hand-delivering to the State Department." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Muscatine address — trackable every step of the way." },
  ],
  faqs: [
    { q: "Can I get an emergency passport in Muscatine before international travel?", a: "Yes. Fast Passport Center provides emergency passport services in Muscatine for travelers with urgent international flights from MLI. Our registered couriers hand-deliver your documents directly to U.S. Department of State facilities, achieving 24–48 hour turnaround — without the 3.5-plus-hour drive to Chicago." },
    { q: "How fast can I renew my passport in Muscatine?", a: "Fast Passport Center offers fast passport renewal in Muscatine in as little as 24–48 hours through our emergency courier service. For less urgent travel, our 3–5 day expedited option provides the best value. Both options include full document review and a dedicated agent." },
    { q: "What is the closest passport agency to Muscatine?", a: "The nearest regional passport agency to Muscatine is the Chicago Passport Agency, approximately 215 miles east via I-80. For urgent processing without the long drive, Fast Passport Center's registered courier service achieves 24–48 hour turnaround from Muscatine without any in-person agency visit required." },
    { q: "Can I get a same-day passport appointment near Muscatine?", a: "Same-day passport appointments are only available at the Chicago Regional Passport Agency — approximately 3.5-plus hours from Muscatine — for documented life-or-death emergencies. For all other urgent travel, Fast Passport Center's 24–48 hour emergency courier processing is the fastest guaranteed option for Muscatine County and Mississippi River region residents." },
    { q: "Do you serve HNI and Bayer employees in Muscatine?", a: "Absolutely. Fast Passport Center regularly serves HNI Corporation, Allsteel, Bayer Crop Science, and Kent Feeds professionals needing fast passports for international business travel. Our courier service handles everything online — you never leave your workplace. Dozens of Muscatine professionals trust us every month." },
    { q: "Can I expedite a child passport in Muscatine?", a: "Yes. Fast Passport Center expedites child passports in Muscatine for minors under 16. Both parents must appear or submit notarized consent, along with the child's birth certificate and both parents' IDs. We walk Muscatine County families through the entire process." },
    { q: "What should I do if I lost my passport before a trip?", a: "If you lost your passport before a trip, contact Fast Passport Center immediately. We provide lost passport replacement services in Muscatine with DS-64 form guidance and identity verification support. Our emergency courier service can get your replacement passport in 24–48 hours." },
    { q: "Do I need to drive to the Chicago Passport Agency?", a: "No. With Fast Passport Center, you complete everything online and ship your documents overnight. Our couriers handle the in-person delivery to State Department facilities. You only need to visit a local acceptance clerk if you're a first-time applicant or need a name change." },
  ],
  photoLocations: [
    { name: "Walmart Supercenter — Muscatine", address: "3003 N Highway 61, Muscatine, IA 52761", hours: "Mon–Sun: 6AM–11PM" },
    { name: "Walgreens — Muscatine", address: "1703 Park Ave, Muscatine, IA 52761", hours: "Mon–Sun: 7AM–11PM" },
    { name: "Walmart Supercenter — Davenport", address: "3101 W Kimberly Rd, Davenport, IA 52806", hours: "Mon–Sun: 6AM–11PM" },
    { name: "Walgreens — West Liberty", address: "103 E 3rd St, West Liberty, IA 52776", hours: "Mon–Sun: 7AM–11PM" },
    { name: "CVS Pharmacy — Davenport", address: "1702 Brady St, Davenport, IA 52803", hours: "Mon–Sun: 8AM–10PM" },
    { name: "FedEx Office — Davenport", address: "3902 Elmore Ave, Davenport, IA 52807", hours: "Mon–Fri: 7AM–9PM, Sat: 8AM–6PM" },
  ],
  dmvLocations: [
    {
      name: "Iowa DOT — Muscatine Driver's License",
      address: "1903 Park Ave, Muscatine, IA 52761",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Driver license and REAL ID services for Muscatine County. Appointment recommended.",
      featured: true,
    },
    {
      name: "Iowa DOT — Davenport Driver's License",
      address: "3319 N Plainview Rd, Davenport, IA 52806",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Serves Scott County. REAL ID available.",
      featured: false,
    },
    {
      name: "Iowa DOT — Iowa City Driver's License",
      address: "1700 S 1st Ave, Iowa City, IA 52240",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Serves Johnson County. REAL ID available.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "MLI",
      name: "Quad Cities International Airport",
      distance: "35 miles northeast of Muscatine",
      address: "2200 69th Ave, Moline, IL 61265",
      note: "Major regional airport with national connections. About 40 minutes from Muscatine.",
      flightUrl: "https://www.qcairport.com/",
      flightLabel: "MLI Airport",
      featured: true,
    },
    {
      code: "CID",
      name: "Eastern Iowa Airport",
      distance: "60 miles northwest of Muscatine",
      address: "2121 Arthur Collins Pkwy SW, Cedar Rapids, IA 52404",
      note: "Serves Cedar Rapids and Eastern Iowa. About 1 hour from Muscatine.",
      flightUrl: "https://www.eiairport.org/",
      flightLabel: "CID Airport",
      featured: false,
    },
    {
      code: "BRL",
      name: "Southeast Iowa Regional Airport",
      distance: "55 miles south of Muscatine",
      address: "2515 Summer St, Burlington, IA 52601",
      note: "Regional airport with daily flights. About 1 hour from Muscatine.",
      flightUrl: "https://www.burlingtoniowaairport.com/",
      flightLabel: "BRL Airport",
      featured: false,
    },
  ],
};